<template>
    <section class="relative text-white font-ww-medium bg-lifeboost-green-50">
      <div class="relative px-4 mx-auto max-w-screen-2xl md:px-6 lg:px-8">
        <div class="max-w-4xl py-10 mx-auto text-center md:py-20">
          <!-- Heading -->
          <h1 class="mb-6 text-4xl font-bold md:text-5xl lg:text-6xl font-ww-medium drop-shadow-2xl" v-html="mainHeading"></h1>
  
          <!-- Description -->
          <p class="mb-6 text-xl md:mb-10 md:text-2xl drop-shadow-2xl" v-html="descriptionText"></p>

            <!-- Button -->
            <a v-if="visibleButton" @click="scrollTo(buttonLink)" class="inline-flex items-center gap-2 px-8 py-4 text-base cursor-pointer md:text-lg btn-red font-ww-medium">
            <span v-html="buttonText"></span>
            <svg class="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
            </svg>
          </a>
        </div>
      </div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    mainHeading: {
      type: String,
      default: 'Your Mindflow Bonuses: The Better Brain Builder Toolkit',
    },
    descriptionText: {
      type: String,
      default: 'Unlock your cognitive potential with this transformative toolkit! Includes:',
    },
    buttonText: {
      type: String,
      default: 'Get Free Resources',
    },
    buttonLink: {
      type: String,
      default: '#resources',
    },
    visibleButton: {
      type: Boolean,
      default: false,
    },
  });
  
  defineBuilderComponent({
    friendlyName: 'HeroTextCta',
    inputs: [
      {
        name: 'mainHeading',
        type: 'richText',
        friendlyName: 'Main Heading',
        defaultValue: 'Your Mindflow Bonuses: The Better Brain Builder Toolkit',
      },
      {
        name: 'descriptionText',
        type: 'richText',
        friendlyName: 'Description Text',
        defaultValue: 'Unlock your cognitive potential with this transformative toolkit! Includes:',
      },
      {
        name: 'buttonText',
        type: 'text',
        friendlyName: 'Button Text',
        defaultValue: 'Get Free Resources',
      },
      {
        name: 'buttonLink',
        type: 'text',
        friendlyName: 'Button Link',
        defaultValue: '#resources',
      },
      {
        name: 'visibleButton',
        type: 'boolean',
        friendlyName: 'Show Button',
        defaultValue: false,
      },
    ],
  });
  </script>
  